import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { APP_ROUTES as ROUTES } from '../../../../app.routes';
import { EAPP_FLOWS } from '@app/core/enums/app.enum';

@Component({
  selector: 'layout-go-back',
  templateUrl: './go-back.component.html',
  styleUrls: ['./go-back.component.scss'],
})
export class GoBackComponent implements OnInit {
  @Input() currentRoute: string;
  @Input() currentFlow: string;
  @Input() step: number;
  @Input() status: number;
  @Input() canRetry: boolean = true;
  @Output() goBackEvent = new EventEmitter<boolean>();

  public FLOWS = EAPP_FLOWS;

  constructor() {}

  ngOnInit(): void {}

  public onGoBack() {
    this.goBackEvent.emit(true);
  }

  public hideOrShow(): boolean {
    return (
      (this.currentRoute === ROUTES.ONBOARDING &&
        this.step > 1 &&
        this.step < 3 &&
        this.status !== 1 &&
        this.canRetry) ||
      (this.currentRoute === ROUTES.AUTH && this.step > 1) ||
      this.currentRoute === ROUTES.INSTALLMENTS ||
      this.currentFlow === this.FLOWS.FQA
    );
  }
}
